import { Component, ChangeDetectionStrategy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { TranslationService } from '@cbcore/services/translation/translation.service';
import { TranslocoService } from '@jsverse/transloco';
import { UtilService } from '@cbcore/services/utils/utils/utils.service';
import { MenuComponent, DesktopFixedMenuComponent } from '@cbui/public_api';
import { FooterComponent } from './components/footer/footer';
import { DisclaimerComponent } from './components/disclaimer/disclaimer';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CommonModule, RouterOutlet, MenuComponent, DesktopFixedMenuComponent, FooterComponent, DisclaimerComponent]
})
export class AppComponent implements OnInit {
  public ready: boolean | undefined;

  constructor(
    private _translationService: TranslationService,
    private _translocoService: TranslocoService,
    private utilService: UtilService
  ) {
    this.utilService.setTheme(false, 'light');
  }

  ngOnInit() {
    this._translationService.ready().subscribe(
      (_data: any) => {
        const qs = (function (a: any) {
          if (a == '') {
            return {};
          }
          const b: any = {};
          for (let i = 0; i < a.length; ++i) {
            const p = a[i].split('=', 2);
            if (p.length == 1) {
              b[p[0]] = '';
            } else {
              b[p[0]] = decodeURIComponent(p[1].replace(/\+/g, ' '));
            }
          }
          return b;
        })(window.location.search.substr(1).split('&'));


        if (qs['lang']) {
          if (this._translocoService.getActiveLang() !== qs['lang']) {
            this._translationService.setLanguage(qs['lang']);
          }
        }

        this.ready = true;
      }
    );
  }
}
